import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-sm font-medium text-[#404040]" }
const _hoisted_2 = {
  key: 0,
  class: "ml-1 rounded-full bg-[#48DDC3] px-2 py-0.5 text-xs text-white"
}
const _hoisted_3 = {
  autocomplete: "off",
  class: "flex flex-col gap-4"
}
const _hoisted_4 = { class: "mb-1 block text-sm font-medium text-gray-800" }
const _hoisted_5 = { class: "mb-1 block text-sm font-medium text-gray-800" }
const _hoisted_6 = { class: "mb-1 block text-sm font-medium text-gray-800" }
const _hoisted_7 = { class: "mt-6 grid grid-cols-2 gap-3" }

import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { FilterIcon } from '@heroicons/vue/solid';

import { useAuraFilters } from '@/composables/useAuraFilters';
import { SelectOptionsService } from '@/services';
import type {
    SelectOptionsServiceGetUsersResult,
    SelectOptionsServiceGetQueuesResult,
    SelectOptionsServiceGetMediasResult,
} from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraFilters',
  setup(__props) {

/**
 * AURA Filters - Filter panel using UiRightPanel pattern from CallList
 * SRP: Only responsible for filter panel UI and data loading
 * Logic delegated to useAuraFilters composable
 */
const { t } = useI18n();
const {
    filterOpened,
    draftFilters,
    hasActiveFilters,
    activeFilterCount,
    applyFilters,
    clearFilters,
} = useAuraFilters();

// Loading states
const isLoadingUsers = ref(false);
const isLoadingQueues = ref(false);
const isLoadingMedias = ref(false);

// Options data
const users = ref<SelectOptionsServiceGetUsersResult[]>([]);
const queues = ref<SelectOptionsServiceGetQueuesResult[]>([]);
const medias = ref<SelectOptionsServiceGetMediasResult[]>([]);

// Load options on mount
onMounted(async () => {
    await Promise.all([loadUsers(), loadQueues(), loadMedias()]);
});

async function loadUsers() {
    isLoadingUsers.value = true;
    try {
        const response = await SelectOptionsService.getUsers();
        users.value = response.data;
    } catch (error) {
        console.error('Failed to load users:', error);
    } finally {
        isLoadingUsers.value = false;
    }
}

async function loadQueues() {
    isLoadingQueues.value = true;
    try {
        const response = await SelectOptionsService.getQueues();
        queues.value = response.data;
    } catch (error) {
        console.error('Failed to load queues:', error);
    } finally {
        isLoadingQueues.value = false;
    }
}

async function loadMedias() {
    isLoadingMedias.value = true;
    try {
        const response = await SelectOptionsService.getMedias();
        medias.value = response.data;
    } catch (error) {
        console.error('Failed to load medias:', error);
    } finally {
        isLoadingMedias.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: _unref(filterOpened),
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(filterOpened) ? (filterOpened).value = $event : null)),
    title: _unref(t)('aura.filters.filter')
  }, {
    button: _withCtx(() => [
      _createElementVNode("button", {
        class: "aura-filters-button flex items-center gap-2 rounded-[10px] border border-[#D4D4D4] bg-white px-3 py-2 hover:bg-gray-50",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (filterOpened.value = true))
      }, [
        _createVNode(_unref(FilterIcon), {
          class: "h-4 w-4 text-[#737373]",
          "aria-hidden": "true"
        }),
        _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('aura.filters.filter')), 1),
        (_unref(hasActiveFilters))
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(activeFilterCount)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(t)('aura.filters.operator')), 1),
          _createVNode(_component_UiMultiselect, {
            modelValue: _unref(draftFilters).operatorId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(draftFilters).operatorId) = $event)),
            name: "operator",
            options: users.value,
            label: "name",
            "value-prop": "id",
            "can-clear": "",
            placeholder: _unref(t)('aura.filters.selectOperator'),
            loading: isLoadingUsers.value,
            searchable: "local",
            "allow-empty": true,
            "show-labels": false
          }, null, 8, ["modelValue", "options", "placeholder", "loading"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('aura.filters.queue')), 1),
          _createVNode(_component_UiMultiselect, {
            modelValue: _unref(draftFilters).queueId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(draftFilters).queueId) = $event)),
            name: "queue",
            options: queues.value,
            label: "name",
            "value-prop": "id",
            "can-clear": "",
            placeholder: _unref(t)('aura.filters.selectQueue'),
            loading: isLoadingQueues.value,
            searchable: "local",
            "allow-empty": true,
            "show-labels": false
          }, null, 8, ["modelValue", "options", "placeholder", "loading"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(t)('aura.filters.media')), 1),
          _createVNode(_component_UiMultiselect, {
            modelValue: _unref(draftFilters).mediaId,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(draftFilters).mediaId) = $event)),
            name: "media",
            options: medias.value,
            label: "label",
            "value-prop": "value",
            primitive: true,
            "can-clear": "",
            placeholder: _unref(t)('aura.filters.selectMedia'),
            loading: isLoadingMedias.value,
            searchable: "local",
            "allow-empty": true,
            "show-labels": false
          }, null, 8, ["modelValue", "options", "placeholder", "loading"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_UiButton, {
            variant: "white",
            "text-variant": "gray-700",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(clearFilters)()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('aura.filters.clear')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_UiButton, {
            variant: "primary",
            "text-variant": "white",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(applyFilters)()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('core.actions.Apply')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})